export const CONFIG = {
    bot_link: "https://t.me/aniversecard_bot",
    rarityOrder: ["Обычная", "Редкая", "Эпическая", "Легендарная", "Мифическая"],
};